import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { Injectable, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  UntypedFormBuilder,
} from "@angular/forms";
// import {
//   MatPaginator,
//   MatSort,
//   MatTableDataSource,
//   MatDialog,
// } from "@angular/material";
import { DaoService } from "./../../services/dao.service";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { CategoryformComponent } from "../categoryform/categoryform.component";
import { SubcategoryformComponent } from "../subcategoryform/subcategoryform.component";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { decryptData, encryptData } from "src/app/services/aes.service";
interface apiManagerModel {
  ApiId: string;
  ApiParentId: string;
  SourceName: string;
  ApiUrl: boolean;
  HttpVerb: string;
  Header: string;
  Parameter: string;
  SampleInput: string;
  AttributeId: string;
  EntityType: string;
  CategoryId: string;
  SubCategoryId: string;
  preCondition: string;
  IsActive?: boolean;
  createdBy?: string;
  createdOn?: string;
  modifiedBy?: string;
  modifiedOn?: string;
  GroupId?: string;
}
@Component({
  selector: "app-api-manager",
  templateUrl: "./api-manager.component.html",
  styleUrls: ["./api-manager.component.scss"],
})
@Injectable()
export class ApiManagerComponent implements OnInit {
  @Input() parentMessage: string;

  disabled = false;

  displayedColumns: string[] = [
    "SouceName",
    "URL",
    "httpVerb",
    "EntityType",
    "Edit",
    "delete",
  ];
  //
  private paginator: MatPaginator;
  public shown = {
    attribute: false,
    grid: false,
    apiForm: true,
  };
  public apiEdit = {
    edit: false,
  };
  //dataSource :any;
  apiListofData: any;
  dataSource: any;
  apiResponse: any;
  apiParentResponse: any;
  apiError: any;
  entity: any;
  category: any;
  subCategory: any;
  ApiManagerListOfData: any;
  apimappingParam: any;
  loader = false;
  ploader = false;
  ispostionalError = false;
  groupId: any;
  parentId: any;
  apiManagerId: any;
  requiredAttributes: any;
  mapped: any;
  hpType = 1;
  ppType = 1;
  Attribute: any;
  sinputAttribute: any;
  parentAttribute: any;
  ChooseEntity = false;
  ChooseCategory = false;
  httb: any;
  selectedRow: any;
  selectedCategoryName: string;
  selectedSubCategoryName: string;
  //
  //
  apiManager = new FormGroup({
    apiId: new FormControl(),
    apiParentId: new FormControl(),
    sourceName: new FormControl(),
    entityType: new FormControl(),
    requiredAttributes: new FormControl(),
    category: new FormControl(),
    subCategory: new FormControl(),
    apiUrl: new FormControl(),
    httpVerb: new FormControl(),
    header: new FormControl(),
    parameter: new FormControl(),
    preCondition: new FormControl(),
    SampleInput: new FormControl(),
  });

  setValidator() {
    const categoryControl = this.apiManager.get("category");
    const subCategoryControl = this.apiManager.get("subCategory");

    this.apiManager
      .get("sourceName")
      .valueChanges.subscribe((sourceNameValue) => {
        if (this.parentId != 0) {
          categoryControl.setValidators(null);
          subCategoryControl.setValidators(null);
        } else {
          categoryControl.setValidators([Validators.required]);
          subCategoryControl.setValidators([Validators.required]);
        }

        categoryControl.updateValueAndValidity();
        subCategoryControl.updateValueAndValidity();
      });
  }

  //Mat Table
  // @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  //AttributeForm
  public validator = {
    errorMessage: "",
    UniqueAttribute: false,
    isCorrelation: false,
  };

  AttributeForm = new FormGroup({
    attributeId: new FormControl(),
    name: new FormControl(),
    uiName: new FormControl(),
    entityType: new FormControl(),
    dataType: new FormControl(),
    isShowInfo: new FormControl(),
    isShowAlgo: new FormControl(),
    isUnique: new FormControl(),
    isCustom: new FormControl(),
    correlationValue: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });
  public created_By: any;

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private daoService: DaoService,
    private token: LstorageService,
    public dialog: MatDialog,
    private spinner: SpinnerService,
    private cdr: ChangeDetectorRef
  ) {
    this.apiManagerId = this.token.getApiManagerId();
    this.groupId = this.token.getGroupId();
    this.parentId = this.token.getParentId();

    if (this.token.getToken() == null) {
      this.router.navigate(["/login"]);
    }

    //  this.daoService.getEntity().subscribe(data => {
    //         this.entity = data;
    //     });
    this.daoService.getEntities().subscribe((data) => {
      var dcrptdData = JSON.parse(decryptData(data.key));
      this.daoService.defaultEntityList(dcrptdData);
      this.daoService.finalEntityList.subscribe((entityList) => {
        this.entity = entityList.map((entity) => entity);
        console.log("Entity Names", this.entity);
      });
      console.log("EntityName", dcrptdData);
      this.spinner.hide();
    });
    this.entity = this.token.getSelectedEntity();
    console.log(this.entity);

    // this.daoService.getCategory().subscribe((data) => {
    //   let userDetails = JSON.parse(decryptData(data.key));
    //   this.daoService.defaultCategoryList(userDetails);
    //   // this.daoService.finalCategoryList.subscribe(
    //   //   (categoryList) => (this.category = categoryList)

    //   // );
    //   this.daoService.finalCategoryList.subscribe((categoryList) => {
    //     this.category = categoryList;
    //     console.log("this.category", this.category); // Log after assignment
    //     this.cdr.detectChanges(); // Trigger change detection if necessary
    //   });
    // });

    this.daoService.getCategory().subscribe((data) => {
      let categoryList = JSON.parse(decryptData(data.key));
      console.log("Category List", categoryList);
      this.daoService.defaultCategoryList(categoryList);
      this.daoService.finalCategoryList.subscribe(
        (categoryList) => (this.category = categoryList)
      );
    });
    console.log("this.category", this.category);

    this.daoService.getSubCategory().subscribe((data) => {
      let data2 = JSON.parse(decryptData(data.key));
      this.daoService.defaultSubCategoryList(data2);
      // this.daoService.finalSubCategoryList.subscribe(
      //   (subCategoryList) => (this.subCategory = subCategoryList)
      // );

      this.daoService.finalSubCategoryList.subscribe((subCategoryList) => {
        this.subCategory = subCategoryList;
        console.log("this.subCategory", this.subCategory); // Log after assignment
        this.cdr.detectChanges(); // Trigger change detection if necessary
      });
      // this.subCategory = data;
    });

    //For merge parent attribute
    if (this.parentId != 0) {
      debugger;

      console.log("enterd attr");
      //Get Parent Attribute
      var pAttribute = [];
      this.daoService
        .getParentAttribute(this.parentId)
        .subscribe((data: any) => {
          data.forEach(function (value) {
            value.name = "response." + value.name;
            pAttribute.push(value);
          });
          this.parentAttribute = pAttribute;
          this.requiredAttributes = this.parentAttribute;
        });
      this.ploader = true;
      //Get Parent Response
      this.daoService
        .getParentResponse(this.parentId)
        .subscribe((data: any) => {
          console.log("Parent Api Response");
          console.log(data);
          this.ploader = false;
          try {
            this.apiParentResponse = JSON.parse(data.data);
          } catch (e) {
            this.apiParentResponse = data.data;
          }
        });
    }

    this.daoService.getApiManagerList().subscribe(
      (data: any) => {
        this.apiListofData = data;
        this.dataSource = new MatTableDataSource(this.apiListofData);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.log("Error: " + error);
      }
    );
  }

  setDataSourceAttributes() {
    //this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.apiManager = this.formBuilder.group({
      apiId: [""],
      apiParentId: [],
      sourceName: ["", Validators.required],
      entityType: ["", Validators.required],
      requiredAttributes: ["", Validators.required],
      category: ["", Validators.required],
      subCategory: ["", Validators.required],
      apiUrl: ["", [Validators.required]],
      httpVerb: ["", [Validators.required]],
      header: this.formBuilder.array([this.getHeader()]),
      parameter: this.formBuilder.array([this.getParameter()]),
      preCondition: [""],
      SampleInput: this.formBuilder.array([this.getSampleInput()]),
    });
    this.apiResponse = null;
    this.apiError = null;
    this.setValidator();

    //for edit apiManager
    if (this.apiManagerId) {
      this.spinner.show();
      this.getApiManager(this.apiManagerId);
    }
  }

  Entitychange(event) {
    debugger;
    this.ChooseEntity = false;
    var data1 = {
      GroupId: event,
    };
    this.daoService
      .getAttributeByEntity(encryptData(JSON.stringify(data1)))
      .subscribe((data: any) => {
        let atrr = JSON.parse(decryptData(data.key));
        if (this.parentAttribute) {
          var selectedAttribute = [];
          atrr.forEach(function (value) {
            value.name = "input." + value.name;
            selectedAttribute.push(value);
          });
          var frequiredAttribute =
            this.parentAttribute.concat(selectedAttribute);
          console.log(atrr);
          console.log(frequiredAttribute);
          this.requiredAttributes = frequiredAttribute;
          this.sinputAttribute = this.requiredAttributes;
          this.Attribute = this.requiredAttributes;
        } else {
          var selectedAttribute = [];
          atrr.forEach(function (value) {
            value.name = "input." + value.name;
            selectedAttribute.push(value);
          });
          this.requiredAttributes = selectedAttribute;
          this.sinputAttribute = this.requiredAttributes;
          this.Attribute = this.requiredAttributes;
        }
      });
  }

  Categorychange(event) {
    this.ChooseCategory = false;
    const selectedCategory = this.category.find(
      (cat) => cat.categoryId === event
    );
    if (selectedCategory) {
      this.selectedCategoryName = selectedCategory.name;
    }
    // console.log("Selected Category Name:", event.name);
    console.log("Selected Category ID:", event);
    var data1 = {
      GroupId: event,
    };
    this.daoService
      .getSubCategoryByCatId(encryptData(JSON.stringify(data1)))
      .subscribe((data: any) => {
        let data2 = JSON.parse(decryptData(data.key));

        console.log("subCat", data2);
        //this.subCategory = data;
        this.daoService.defaultSubCategoryList(data2);
      });
  }

  apiAdd() {
    this.token.clear();
    this.apiEdit.edit = false;
    this.shown.grid = false;
    this.shown.apiForm = true;
    this.apiManager = this.formBuilder.group({
      apiId: [""],
      sourceName: ["", Validators.required],
      entityType: ["", Validators.required],
      requiredAttributes: ["", Validators.required],
      category: ["", Validators.required],
      subCategory: ["", Validators.required],
      apiUrl: ["", [Validators.required]],
      httpVerb: ["", [Validators.required]],
      header: this.formBuilder.array([this.getHeader()]),
      parameter: this.formBuilder.array([this.getParameter()]),
      preCondition: [""],
      SampleInput: this.formBuilder.array([this.getSampleInput()]),
    });
  }

  apiList() {
    this.daoService.getApiManagerList().subscribe(
      (data: any) => {
        this.apiListofData = data;
        this.dataSource = new MatTableDataSource(this.apiListofData);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.log("Error: " + error);
      }
    );
    this.shown.grid = true;
    this.shown.apiForm = false;
  }

  getApiManager(id) {
    this.shown.grid = false;
    this.shown.apiForm = true;
    this.apiEdit.edit = true;
    this.apiResponse = null;
    this.apiError = null;
    this.token.clear();
    var data1 = {
      GroupId: id,
    };
    this.daoService
      .getApimanagerById(encryptData(JSON.stringify(data1)))
      .subscribe((data: any) => {
        let data2 = JSON.parse(decryptData(data.key));
        let attId = JSON.parse(data2.attributeId);
        this.httb = data2.httpVerb == 0 ? "Get" : "Post";

        var sub = {
          GroupId: data2.categoryId,
        };
        this.daoService
          .getSubCategoryByGuidCatId(encryptData(JSON.stringify(sub)))
          .subscribe((data: any) => {
            let data2 = JSON.parse(decryptData(data.key));

            this.subCategory = data2;
          });
        var ent = {
          GroupId: data2.entityType,
        };
        this.daoService
          .getAttributeByEntity(encryptData(JSON.stringify(ent)))
          .subscribe((AttributeData: any) => {
            let atrr = JSON.parse(decryptData(AttributeData.key));

            this.spinner.hide();
            if (this.parentAttribute) {
              var selectedAttribute = [];
              atrr.forEach(function (value) {
                value.name = "input." + value.name;
                selectedAttribute.push(value);
              });
              var frequiredAttribute =
                this.parentAttribute.concat(selectedAttribute);
              this.requiredAttributes = frequiredAttribute;
              this.sinputAttribute = this.requiredAttributes;
              this.Attribute = this.requiredAttributes;
            } else {
              var selectedAttribute = [];
              atrr.forEach(function (value) {
                value.name = "input." + value.name;
                selectedAttribute.push(value);
              });
              this.requiredAttributes = selectedAttribute;
              this.selectedRow = this.requiredAttributes.find(
                (item) => item.attributeId === data2.requiredAttribute
              );
              this.sinputAttribute = this.requiredAttributes;
              this.Attribute = this.requiredAttributes;
            }
          });

        let head = JSON.parse(data2.header);
        let param = JSON.parse(data2.parameter);
        let sample = JSON.parse(data2.sampleInput);
        // let reqAttr = JSON.parse(data2.requiredAttributes);
        // data2.requiredAttributes = reqAttr[0];

        // ApiManagerList=data;
        //alert(data.header[0].key);
        var dynamicHeader = this.formBuilder.array([]);

        var dynamicParameter = this.formBuilder.array([]);

        var dynamicsampleInput = this.formBuilder.array([]);

        for (var i = 0; i < head.length; i++) {
          dynamicHeader.push(
            this.bindHeader(head[i].Key, head[i].parameterType, head[i].Value)
          );
        }

        console.log("dynamicHeader", dynamicHeader);

        for (var i = 0; i < param.length; i++) {
          dynamicParameter.push(
            this.bindParameter(
              param[i].Key,
              param[i].Value,
              param[i].parameterType
            )
          );
        }

        console.log("dynamicParameter", dynamicParameter);
        for (var i = 0; i < sample.length; i++) {
          dynamicsampleInput.push(
            this.bindSampleInput(sample[i].Key, sample[i].Value)
          );
        }

        console.log("dynamicsampleInput", dynamicsampleInput);
        // this.Attribute = data.requiredAttributes;
        this.sinputAttribute = data2.requiredAttributes;

        //            var selectedAttribute = [];
        //            // this.Attribute = this.daoService.finalRequiredAttribute;
        //            data.requiredAttributes.forEach(function(value) {
        //                selectedAttribute.push("input." + value);
        //            });

        this.Attribute = data2.requiredAttributes;

        this.apiManager = this.formBuilder.group({
          apiId: [id],
          sourceName: [data2.sourceName],
          entityType: [data2.entityType],
          //requiredAttributes: [data2.requiredAttributes],
          requiredAttributes: [attId],
          // requiredAttributes: [data2.attributeId],
          category: [data2.categoryId],
          subCategory: [data2.subCategoryId],
          apiUrl: [data2.apiUrl],
          httpVerb: [this.httb],
          header: dynamicHeader,
          parameter: dynamicParameter,
          preCondition: [data2.preCondition],
          SampleInput: dynamicsampleInput,
        });
        console.log("this.apiManager Result", this.apiManager);
      });
  }

  deleteApiManager(id, index) {
    this.daoService.deleteApimanagerById(id).subscribe((data: any) => {
      this.apiListofData = this.removeFromArrayOfHash(
        this.apiListofData,
        "apiId",
        data.data.apiId
      );
      // this.apiListofData = this.apiListofData.splice(0, index);
      this.dataSource = new MatTableDataSource(this.apiListofData);
      this.dataSource.paginator = this.paginator;
    });
  }

  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter((l_cur_row) => {
      return l_cur_row[p_key] != p_value_to_remove;
    });
  }

  apiTest() {
    //this.spinner.show();
    this.apiResponse = null;
    this.apiError = null;
    // this.loader = true;
    this.ispostionalError = false;
    console.log("Api manager");
    console.log(this.apiManager.value);
    console.log("this.parentId", this.parentId);
    if (this.parentId) {
      this.apiManager.value.apiParentId = this.parentId;
    }
    console.log("this.apiManager.value", this.apiManager.value);
    //Add Api to staging
    var info = this.selectedCategoryName + ">>" + this.selectedSubCategoryName;
    console.log("info", info);
    //alert(info);
    debugger;
    const apiManager: apiManagerModel = {
      ApiId: this.apiManager.value.apiId,
      ApiParentId: this.apiManager.value.apiParentId,
      SourceName: this.apiManager.value.sourceName,
      ApiUrl: this.apiManager.value.apiUrl,
      HttpVerb: this.apiManager.value.httpVerb,
      Header: this.apiManager.value.header,
      Parameter: this.apiManager.value.parameter,
      SampleInput: this.apiManager.value.SampleInput,
      AttributeId: this.apiManager.value.requiredAttributes,
      EntityType: this.apiManager.value.entityType,
      CategoryId: this.apiManager.value.category,
      SubCategoryId: this.apiManager.value.subCategory,
      preCondition: this.apiManager.value.preCondition,
      modifiedBy: this.daoService.loggedUser.UserUniqueId,
      createdBy: this.daoService.loggedUser.UserUniqueId,
      GroupId: this.groupId,
    };
    console.log("apiManagerData", apiManager);
    this.token.saveInfoHighlights(info); //for store info highlights
    this.daoService
      .addApitoStaging(encryptData(JSON.stringify(apiManager)))
      .subscribe(
        (data: any) => {
          console.log("addApitoStagingData", data);
          this.apimappingParam = data;

          console.log("Api Data");
          console.log(data);

          let data2 = JSON.parse(decryptData(data.data));
          this.apimappingParam = data2;
          console.log(
            "this.apimappingParam.ApiData",
            this.apimappingParam.ApiData
          );
          console.log("data2", data2);
          this.token.saveApiData(this.apimappingParam.ApiData);
          //  alert(this.apimappingParam.data.ApiData.ApiId);
          this.token.saveApiId(this.apimappingParam.ApiData.ApiId);
          //this.token.saveApiId(this.apimappingParam.ApiData.Id);
          this.token.saveApiResultId(this.apimappingParam.ApiresultId);
          this.loader = false;
          this.spinner.hide();

          try {
            this.apiResponse = JSON.parse(this.apimappingParam.ApiResponse);
            this.spinner.hide();
          } catch (e) {
            this.apiResponse = this.apimappingParam.ApiResponse;
            this.spinner.hide();
          }

          this.token.saveApiResponse(this.apiResponse);
          if (this.apimappingParam.ApiMappingData) {
            this.token.saveApiMappingData(
              this.apimappingParam.ApiMappingData.MappingAttributes
            );
            this.token.saveApiMappingId(
              this.apimappingParam.ApiMappingData.ApiMappingId
            );
          }
          this.token.getApiMappingData();
          this.token.saveApiDyanamicAttribute(
            this.apimappingParam.MappingAttributes
          );
          this.token.saveApiStaticData(this.apimappingParam.Attributes);
        },

        (err) => {
          console.log(err),
            (this.loader = false),
            this.spinner.hide(),
            (this.apiError = err);
        } // If got an error
      );
  }

  //Dynamic Header Begun
  /**
   * Create form Header
   */
  private getHeader() {
    return this.formBuilder.group({
      key: [""],
      parameterType: [""],
      value: [""],
    });
  }

  private bindHeader(key, positionType, value) {
    return this.formBuilder.group({
      key: [key],
      parameterType: [positionType],
      value: [value],
    });
  }

  private bindParameter(key, value, isPositional) {
    return this.formBuilder.group({
      key: [key],
      value: [value],
      parameterType: [isPositional],
    });
  }

  private bindSampleInput(key, value) {
    return this.formBuilder.group({
      key: [key],
      value: [value],
    });
  }

  /**
   * Add new Header row into form
   */
  addHeader() {
    const control = this.apiManager.get("header") as FormArray; // Cast 'header' to FormArray
    control.push(this.getHeader()); // Assuming getHeader() returns a new FormControl or FormGroup
  }

  /**
   * Remove Header row from form on click delete button
   */
  removeHeader(i: number) {
    const control = this.apiManager.get("header") as FormArray;
    control.removeAt(i);
    if (i == 0) {
      control.push(this.getHeader());
    }
  }

  /**
   * This is one of the way how clear Headers fields.
   */
  clearAllHeaders() {
    const control = this.apiManager.get("header") as FormArray;
    while (control.length) {
      control.removeAt(control.length - 1);
    }
    control.clearValidators();
    control.push(this.getHeader());
  }
  //Dynamic Header E
  //Dynamic Parameter Begin
  private getParameter() {
    return this.formBuilder.group({
      key: [""],
      parameterType: [""],
      value: [""],
    });
  }

  addParameter() {
    const control = this.apiManager.get("parameter") as FormArray;
    control.push(this.getParameter());
  }

  removeParameter(i: number) {
    const control = this.apiManager.get("parameter") as FormArray;
    control.removeAt(i);
    if (i == 0) {
      control.push(this.getParameter());
    }
  }

  clearAllParameter() {
    const control = this.apiManager.get("parameter") as FormArray;
    while (control.length) {
      control.removeAt(control.length - 1);
    }
    control.clearValidators();
    control.push(this.getParameter());
  }

  //Attribute
  Attributeshange(value) {
    this.ChooseEntity = false;
    var EntityName = this.apiManager.value.entityType;
    if (!EntityName) {
      this.ChooseEntity = true;
    }
    var selectedAttribute = [];
  }

  //Dynamic Parameter E

  //Dynamic sample input Begin
  private getSampleInput() {
    return this.formBuilder.group({
      key: [""],
      value: [""],
      // parameterType: [""],
    });
  }

  addSampleInput() {
    //  const control = <FormArray>this.apiManager.controls["SampleInput"];
    const control = this.apiManager.get("SampleInput") as FormArray;
    control.push(this.getSampleInput());
  }

  removeSampleInput(i: number) {
    const control = this.apiManager.get("SampleInput") as FormArray;
    control.removeAt(i);
    if (i == 0) {
      control.push(this.getParameter());
    }
  }

  clearAllSampleInput() {
    //   const control = <FormArray>this.apiManager.controls["SampleInput"];
    const control = this.apiManager.get("SampleInput") as FormArray;
    while (control.length) {
      control.removeAt(control.length - 1);
    }
    control.clearValidators();
    control.push(this.getSampleInput());
  }
  //Dynamic SampleInput End

  onChange(event, index, parameter) {
    for (var i = 0; i < parameter.length; i++) {
      if (i != index) {
        parameter[i].value.isPositional = false;
      }
    }
  }

  //Add Category
  AddCategory(): void {
    const dialogRef = this.dialog.open(CategoryformComponent, {
      panelClass: "custom-dialog-container",
      width: "442px",
      height: "210px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((categoryList) => {
      this.daoService.getCategory().subscribe((data) => {
        let userDetails = JSON.parse(decryptData(data.key));
        this.daoService.defaultCategoryList(userDetails);
        this.daoService.finalCategoryList.subscribe(
          (categoryList) => (this.category = categoryList)
        );
      });
    });
  }

  //Add SubCategory
  Addsubcategory(): void {
    this.ChooseCategory = false;
    var categoryId = this.apiManager.value.category;
    var catName = this.apiManager.value.category;
    this.daoService.categoryName(catName);
    if (catName) {
      const dialogRef = this.dialog.open(SubcategoryformComponent, {
        panelClass: "custom-dialog-container",
        width: "500px",
        height: "285px",
        autoFocus: true,
      });
      dialogRef.beforeClosed().subscribe((categoryList) => {
        this.daoService.getSubCategory().subscribe((data) => {
          this.daoService.defaultSubCategoryList(data);
          this.daoService.finalSubCategoryList.subscribe(
            (subCategoryList) => (this.subCategory = subCategoryList)
          );
          // this.subCategory = data;
        });
      });
    } else {
      this.ChooseCategory = true;
    }
  }

  AddAttribute(): void {
    this.ChooseEntity = false;
    var EntityName = this.apiManager.value.entityType;
    console.log("EntityName", EntityName);
    this.token.saveEntityName(EntityName);
    if (EntityName) {
      this.shown.attribute = true;
      this.shown.apiForm = false;

      this.created_By = jwtDecode(this.token.getToken());
      this.Attribute = this.formBuilder.group({
        attributeId: [""],
        name: [""],
        uiName: [""],
        entityType: [this.token.getEntityName(), [Validators.required]],
        dataType: ["1001"],
        isShowInfo: [false],
        isShowAlgo: [false],
        isUnique: [false],
        isCustom: [false],
        correlationValue: [0],
        isActive: ["true"],
        createdBy: [this.daoService.loggedUser.UserUniqueId],
        createdOn: ["2019-11-05T17:04:56.351Z"],
        modifiedBy: [""],
        modifiedOn: ["2019-11-05T17:35:10.052Z"],
      });
      console.log("this.Attribute", this.Attribute);
    } else {
      this.ChooseEntity = true;
    }
  }
  //For Attribute form
  createAttribute() {
    console.log("createAttribute");
    this.validator.UniqueAttribute = false;
    this.validator.isCorrelation = false;
    if (this.Attribute.value.isShowAlgo) {
      if (this.Attribute.value.correlationValue == 0) {
        this.validator.isCorrelation = true;
        this.spinner.hide();
      } else {
        this.daoService
          .AddAttribute(encryptData(JSON.stringify(this.Attribute.value)))
          .subscribe(
            (data: any) => {
              //Get Attribute data

              var data1 = {
                GroupId: this.Attribute.value.entityType,
              };
              this.daoService
                .getAttributeByEntity(encryptData(JSON.stringify(data1)))
                .subscribe((data: any) => {
                  this.spinner.hide();
                  let atrr = JSON.parse(decryptData(data.key));
                  if (this.parentAttribute) {
                    var selectedAttribute = [];
                    atrr.forEach(function (value) {
                      value.name = "input." + value.name;
                      selectedAttribute.push(value);
                    });
                    var frequiredAttribute =
                      this.parentAttribute.concat(selectedAttribute);
                    console.log(atrr);
                    console.log(frequiredAttribute);
                    this.requiredAttributes = frequiredAttribute;
                    this.sinputAttribute = this.requiredAttributes;
                    this.Attribute = this.requiredAttributes;
                  } else {
                    var selectedAttribute = [];
                    atrr.forEach(function (value) {
                      value.name = "input." + value.name;
                      selectedAttribute.push(value);
                    });
                    this.requiredAttributes = selectedAttribute;
                    this.sinputAttribute = this.requiredAttributes;
                    this.Attribute = this.requiredAttributes;
                  }
                });

              this.shown.attribute = false;
              this.shown.apiForm = true;
            },
            (error) => {
              console.log(error);
              this.spinner.hide();
              this.validator.UniqueAttribute = true;
              this.validator.errorMessage = error.error.userMessage;
            }
          );
      }
    } else {
      this.daoService
        .AddAttribute(JSON.stringify(this.Attribute.value))
        .subscribe(
          (data: any) => {
            //Get Attribute data
            var data1 = {
              GroupId: this.Attribute.value.entityType,
            };
            this.daoService
              .getAttributeByEntity(encryptData(JSON.stringify(data1)))
              .subscribe((data: any) => {
                this.spinner.hide();
                let atrr = JSON.parse(decryptData(data.key));
                if (this.parentAttribute) {
                  var selectedAttribute = [];
                  atrr.forEach(function (value) {
                    value.name = "input." + value.name;
                    selectedAttribute.push(value);
                  });
                  var frequiredAttribute =
                    this.parentAttribute.concat(selectedAttribute);
                  console.log(atrr);
                  console.log(frequiredAttribute);
                  this.requiredAttributes = frequiredAttribute;
                  this.sinputAttribute = this.requiredAttributes;
                  this.Attribute = this.requiredAttributes;
                } else {
                  var selectedAttribute = [];
                  atrr.forEach(function (value) {
                    value.name = "input." + value.name;
                    selectedAttribute.push(value);
                  });
                  this.requiredAttributes = selectedAttribute;
                  this.sinputAttribute = this.requiredAttributes;
                  this.Attribute = this.requiredAttributes;
                }
              });

            this.shown.attribute = false;
            this.shown.apiForm = true;
          },
          (error) => {
            console.log(error);
            this.spinner.hide();
            this.validator.UniqueAttribute = true;
            this.validator.errorMessage = error.error.userMessage;
          }
        );
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (this.Attribute.value.correlationValue.length > 2) {
      return false;
    }

    return true;
  }

  backapimanager() {
    this.shown.attribute = false;
    this.shown.apiForm = true;
  }

  handleInput(event) {
    if (event.which === 32 && !this.Attribute.value.name.length)
      event.preventDefault();
  }
  SubCategorychange(event) {
    this.ChooseCategory = false;
    const selectedSubCategory = this.subCategory.find(
      (cat) => cat.subcategoryId === event
    );
    if (selectedSubCategory) {
      this.selectedSubCategoryName = selectedSubCategory.name;
    }
  }
  // onParameterTypeChange(value: number, i: number) {
  //   this.apiManager.value.SampleInput[i].parameterType = value;
  // }
}
